import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function Modal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-140">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-charcoal/60 backdrop-blur-sm" onClick={onClose} data-id="element-141">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-white text-charcoal rounded-sm max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-142">
            <div className="flex items-center justify-between p-6 border-b border-cream-dark sticky top-0 bg-white z-10" data-id="element-143">
              <h3 className="font-serif text-2xl" data-id="element-144">{title}</h3>
              <button onClick={onClose} className="p-2 hover:bg-cream rounded-full transition-colors" data-id="element-145">
                <XIcon className="w-5 h-5 text-charcoal-light" data-id="element-146" />
              </button>
            </div>
            <div className="p-6 text-charcoal-light leading-relaxed space-y-4" data-id="element-147">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-sage text-cream/80 py-12 border-t border-sage-dark" data-id="element-148">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-149">
          <div className="text-center md:text-left" data-id="element-150">
            <h3 className="font-serif text-xl text-white mb-2" data-id="element-151">
              Rutina de Autocuidado para Pies Sensibles
            </h3>
            <p className="text-sm" data-id="element-152">
              © {new Date().getFullYear()} Todos los derechos reservados.
            </p>
          </div>

          <div className="flex items-center gap-4 text-sm" data-id="element-153">
            <span data-id="element-154">Producto digital</span>
            <span className="w-1 h-1 rounded-full bg-bronze" data-id="element-155" />
            <span data-id="element-156">PDF en español</span>
          </div>

          <div className="flex items-center gap-6 text-sm" data-id="element-157">
            <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors underline underline-offset-4 decoration-cream/20 hover:decoration-white" data-id="element-158">
              Privacy Policy
            </button>
            <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors underline underline-offset-4 decoration-cream/20 hover:decoration-white" data-id="element-159">
              Terms of Service
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Privacy Policy" data-id="element-160">
        <p className="font-semibold text-charcoal" data-id="element-161">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p data-id="element-162">
          Esta política de privacidad describe cómo recopilamos, usamos y
          protegemos la información proporcionada al adquirir nuestros productos
          digitales.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-163">
          Información que recopilamos
        </h4>
        <p data-id="element-164">
          Al realizar una compra, podemos recopilar la siguiente información:
        </p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-165">
          <li data-id="element-166">Nombre completo</li>
          <li data-id="element-167">Dirección de correo electrónico</li>
          <li data-id="element-168">
            Información de pago (procesada de forma segura por nuestro proveedor
            de pagos)
          </li>
        </ul>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-169">
          Uso de la información
        </h4>
        <p data-id="element-170">La información recopilada se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-171">
          <li data-id="element-172">Procesar y entregar tu compra digital</li>
          <li data-id="element-173">Enviar confirmaciones de pedido y acceso al producto</li>
          <li data-id="element-174">Brindar soporte relacionado con tu compra</li>
        </ul>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-175">
          Protección de datos
        </h4>
        <p data-id="element-176">
          No vendemos, compartimos ni transferimos tu información personal a
          terceros. Implementamos medidas de seguridad razonables para proteger
          tus datos.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-177">Cookies</h4>
        <p data-id="element-178">
          Nuestro sitio puede utilizar cookies para mejorar la experiencia de
          navegación. Puedes configurar tu navegador para rechazar cookies si lo
          prefieres.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-179">Tus derechos</h4>
        <p data-id="element-180">
          Tienes derecho a solicitar acceso, corrección o eliminación de tus
          datos personales en cualquier momento.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Terms of Service" data-id="element-181">
        <p className="font-semibold text-charcoal" data-id="element-182">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <p data-id="element-183">
          Al adquirir este producto digital, aceptas los siguientes términos y
          condiciones.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-184">
          Producto digital
        </h4>
        <p data-id="element-185">
          Este es un producto 100% digital en formato PDF. No se realiza envío
          de productos físicos. El acceso al archivo se proporciona de forma
          inmediata después de completar la compra.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-186">Uso personal</h4>
        <p data-id="element-187">
          El contenido de esta guía es para uso personal y privado. Queda
          prohibida su reproducción, distribución, reventa o compartición total
          o parcial sin autorización previa por escrito.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-188">
          Naturaleza del contenido
        </h4>
        <p data-id="element-189">
          Esta guía es un recurso educativo de autocuidado general. No
          constituye asesoramiento médico, profesional ni personalizado. No
          sustituye la consulta con un profesional de la salud.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-190">
          Política de reembolso
        </h4>
        <p data-id="element-191">
          Debido a la naturaleza digital del producto y su entrega inmediata, no
          se aceptan devoluciones ni reembolsos una vez completada la descarga.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-192">
          Propiedad intelectual
        </h4>
        <p data-id="element-193">
          Todo el contenido, diseño y estructura de esta guía están protegidos
          por derechos de autor. Todos los derechos reservados.
        </p>

        <h4 className="font-serif text-lg text-charcoal mt-6" data-id="element-194">
          Modificaciones
        </h4>
        <p data-id="element-195">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          esta página.
        </p>
      </Modal>
    </>;
}